/**
    Parses numbers and strings into valid JavaScript Date objects, supporting years, quarters, months, and ISO 8601 formats.
    @param d The date value to parse (number, string, or Date).
*/ export default function(d) {
    // returns if falsey or already Date object
    if ([
        false,
        undefined,
        NaN
    ].includes(d) || d.constructor === Date) return d;
    else if (d.constructor === Number && "".concat(d).length > 5 && d % 1 === 0) return new Date(d);
    var s = "".concat(d);
    // tests for MM/DD/YYYY and MM-DD-YYYY format
    var dayFormat = new RegExp(/^\d{1,2}[./-]\d{1,2}[./-](-*\d{1,4})$/g).exec(s);
    if (dayFormat) {
        var year = dayFormat[1];
        if (year.indexOf("-") === 0) s = s.replace(year, year.substring(1));
        var date = new Date(s);
        date.setFullYear(year);
        return date;
    }
    // tests for full Date object string format
    var strFormat = new RegExp(/^[A-z]{1,3} [A-z]{1,3} \d{1,2} (-*\d{1,4}) \d{1,2}:\d{1,2}:\d{1,2} [A-z]{1,3}-*\d{1,4} \([A-z]{1,3}\)/g).exec(s);
    if (strFormat) {
        var year1 = strFormat[1];
        if (year1.indexOf("-") === 0) s = s.replace(year1, year1.substring(1));
        var date1 = new Date(s);
        date1.setFullYear(year1);
        return date1;
    }
    // tests for quarterly formats (ie. "QX YYYY" and "YYYY QX")
    var quarterPrefix = new RegExp(/^([qQ]{1}[1-4]{1}|[1-4]{1}[qQ]{1})[\s|-]{0,1}(-*\d{1,4})$/g).exec(s);
    var quarterSuffix = new RegExp(/^(-*\d{1,4})[\s|-]{0,1}([qQ]{1}[1-4]{1}|[1-4]{1}[qQ]{1})$/g).exec(s);
    if (quarterPrefix || quarterSuffix) {
        var quarter = +(quarterPrefix ? quarterPrefix[1] : quarterSuffix[2]).toLowerCase().replace("q", "");
        var year2 = +(quarterPrefix ? quarterPrefix[2] : quarterSuffix[1]);
        var date2 = new Date(year2, quarter * 3 - 3, 1);
        date2.setFullYear(year2);
        return date2;
    }
    // tests for monthly formats (ie. "MM-YYYY" and "YYYY-MM")
    var monthPrefix = new RegExp(/^([-*\d]{1,2})-(-*\d{1,4})$/g).exec(s);
    var monthSuffix = new RegExp(/^(-*\d{1,4})-([-*\d]{1,2})$/g).exec(s);
    if (monthPrefix || monthSuffix) {
        var month = +(monthPrefix ? monthPrefix[1] : monthSuffix[2]);
        var year3 = +(monthPrefix ? monthPrefix[2] : monthSuffix[1]);
        var date3 = new Date(year3, month - 1, 1);
        date3.setFullYear(year3);
        return date3;
    }
    // detects if only passing a year value
    if (!s.includes("/") && !s.includes(" ") && (!s.includes("-") || !s.indexOf("-"))) {
        var date4 = new Date(+s, 0, 1);
        date4.setFullYear(d);
        return date4;
    }
    var iso8601 = new RegExp(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/g).exec(s);
    if (iso8601) return new Date(s);
    // falls back to Date object, replacing hyphens with slashes
    return new Date(s.replace(/-/g, "/"));
}

//# sourceMappingURL=date.js.map